export const validationIdsMatch = (validatedIds, currentIds) =>
  String(validatedIds?.clientId) === String(currentIds?.clientId) &&
  String(validatedIds?.caseId) === String(currentIds?.caseId);

export const shouldValidateAccess = ({ hasInitialized, validatedIds, currentIds }) =>
  !hasInitialized || !validationIdsMatch(validatedIds, currentIds);
